import React from "react";
import "./styles.css";
import Aprovado from "../../assets/approved.svg";
import Error from "../../assets/error.svg";
import Fechar from "../../assets/fechar.png";

export default function Alert({ title, text, closeModal, error }) {
  return (
    <div className="popup-area">
      <div className="popup-container">
        <div className="popup-fechar">
          <img src={Fechar} alt="fechar" onClick={closeModal} />
        </div>
        <div className="popup-simbol">
          <img
            src={error ? Error : Aprovado}
            alt={error ? "falha" : "sucesso"}
          />
        </div>
        <h2 class={error ? "popup-title-error" : "popup-title"}>{title}</h2>
        <p>{text}</p>
        <a
          href="#"
          className={error ? "popup-button-error" : "popup-button"}
          onClick={closeModal}
        >
          {" "}
          OK
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js